import { getFeatureVisitedCount } from './feature-visited';

export const hasSeenAnyNudgeExceptMsr = () => {
	if (hasSeenJpdNudge()) {
		return true;
	}
	if (hasSeenJiraNudge()) {
		return true;
	}
	if (hasSeenLoomNudge()) {
		return true;
	}
	return false;
};

export const hasSeenJpdNudge = () => {
	if (getFeatureVisitedCount('crossJoinNudgesConfluenceToJpd') > 0) {
		return true;
	}
	return false;
};

export const hasSeenJiraNudge = () => {
	if (getFeatureVisitedCount('crossJoinNudgesV3') > 0) {
		return true;
	}
	return false;
};

export const hasSeenLoomNudge = () => {
	//TODO
	return false;
};
